import * as ActionTypes from "services/state/action-types";
import { get } from "../../network/endpoint";

export function openTechnicianModal() {
  return (dispatch) => {
    return dispatch({
      type: ActionTypes.FOLLOW_TECHNICIAN_MODAL_STATE,
      payload: true,
    });
  };
}

export function closeTechnicianModal() {
  return (dispatch) => {
    return dispatch({
      type: ActionTypes.FOLLOW_TECHNICIAN_MODAL_STATE,
      payload: false,
    });
  };
}

export function getTechnician(activityId, isModalOpen) {
  return (dispatch) => {
    const config = {
      pathValues: { activityId },
    };
    const request = get("technicians", config);

    return dispatch({
      type: ActionTypes.GET_TECHNICIAN,
      payload: { ...request, isModalOpen },
    });
  };
}

export function getTechnicians(serviceOrderTechnicians, isModalOpen) {
  return (dispatch) => {
    if (isModalOpen) {
      dispatch({
        type: ActionTypes.GET_TECHNICIAN,
        payload: { isModalOpen },
      });
    }
    serviceOrderTechnicians.forEach((activityId) => {
      if (activityId && !!activityId) {
        dispatch(getTechnician(activityId, isModalOpen));
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/state/technician/action.js